import { UntypedFormArray } from '@angular/forms';
import { ExportConfig, FileType, FormType } from './export.model';
import { FloorSizeStrategy } from './new-export-to-excel.service';

const atLeastOneSelected = (form: UntypedFormArray) =>
  !Object.values(form.value).some(value => value) ? { atLeastOneSelected: true } : null;

export const EXPORT_FORM_CONFIG: ExportConfig[] = [
  {
    label: 'exportAndSettings.showOptions',
    key: 'showOptions',
    options: [{ label: 'exportAndSettings.showElevators', key: 'showElevators' }],
    formType: FormType.GROUP,
  },
  {
    label: 'exportAndSettings.showParameters',
    key: 'showParameters',
    formType: FormType.GROUP,
    options: [
      {
        label: 'exportAndSettings.spaceSizeSFSM',
        key: 'spaceSize',
      },
      {
        label: 'exportAndSettings.leaseEndingDate',
        key: 'leaseEndingDate',
      },
      {
        label: 'exportAndSettings.rentRate',
        key: 'rentDate',
      },
      {
        label: 'exportAndSettings.suiteNumber',
        key: 'suiteNumber',
      },
      {
        label: 'exportAndSettings.tenancyRepresentative',
        key: 'tenantRepAgency',
      },
    ],
  },
  {
    label: 'exportAndSettings.legends',
    key: 'legends',
    formType: FormType.GROUP,
    validators: [atLeastOneSelected],
    options: [
      {
        label: 'exportAndSettings.expiry',
        key: 'expiry',
      },
      {
        label: 'exportAndSettings.leaseYear',
        key: 'leaseYear',
      },
      {
        label: 'exportAndSettings.industry',
        key: 'industry',
      },
      {
        label: 'exportAndSettings.tenancyRepresentative',
        key: 'agency',
      },
      {
        label: 'exportAndSettings.usage',
        key: 'usage',
      },
      {
        label: 'exportAndSettings.occupier',
        key: 'occupier',
      },
      {
        label: 'exportAndSettings.noneLegend',
        key: 'none',
        icon: 'mapinfo-icon',
        tooltip: 'exportAndSettings.withoutColorsFilter',
      },
    ],
  },
  {
    label: 'exportAndSettings.floorStrategy.optionHeader',
    key: 'sizeStrategy',
    formType: FormType.CONTROL,
    options: [
      {
        label: 'exportAndSettings.floorStrategy.buildingStrategy',
        tooltip: 'exportAndSettings.floorStrategy.buildingStrategyDesc',
        key: FloorSizeStrategy.Building,
      },
      {
        label: 'exportAndSettings.floorStrategy.floorStrategy',
        tooltip: 'exportAndSettings.floorStrategy.floorStrategyDesc',
        key: FloorSizeStrategy.Floor,
      },
    ],
  },
  {
    label: 'exportAndSettings.fileType',
    key: 'fileType',
    formType: FormType.CONTROL,
    options: [{ label: FileType.Excel, key: FileType.Excel }],
  },
];
